import classNames from "classnames";
import { Title } from "components/typography/Title";
import s from "./PremiumFeatures.module.scss";
import cs from "@/styles/modules/card.module.scss";
import { useEffect } from "react";
import { baseUrl, orderFormUrl } from "@/const";
import {
  useOrderForm,
  useOrderFormInitialSetup,
  getExtraFeatureName,
  getExtraFeaturesFromEntity,
} from "@/lib/priceCalculator";
import { SpriteIcon } from "@/components/UI/SpriteIcon";
import iconArrowRightB from "public/img/icons/svg/angle-right-b.svg";
import { IconImage } from "@/components/UI/IconImage";
import cn from "classnames";
import Image from "next/image";
import { extraFeaturesImages } from "@/helpers/extraFeatures";

type PremiumFeaturesProps = {
  className?: string;
};

export const PremiumFeatures = ({ className }: PremiumFeaturesProps) => {
  const { config, formValues, setFormValues, defaults, dispatch } = useOrderFormInitialSetup(
    baseUrl,
    orderFormUrl
  );

  const { submit } = useOrderForm(config, formValues, defaults, baseUrl);

  useEffect(() => {
    if (formValues.selectedFeatures?.length) submit();
  }, [formValues.selectedFeatures, submit]);

  return (
    <div className={classNames(s.wrapper, className)}>
      <IconImage size={40} icon="star" className={s.iconImg} />
      <Title level={4} tag={2} className={s.title}>
        Try premium features
      </Title>
      <div className={s.subheading}>
        Enhance your paper quality with our premium services for additional cost.
      </div>
      <div className={s.list}>
        {config &&
          getExtraFeaturesFromEntity(config).map(
            ({ idExtraFeatureType, customerName, percentageSurcharge, flatSurcharge }) => (
              <div
                key={idExtraFeatureType}
                className={cn(cs.cardGlassHover, s.item)}
                onClick={() => {
                  setFormValues({
                    ...formValues,
                    selectedFeatures: [idExtraFeatureType],
                  });
                }}
              >
                <div className={s.itemContent}>
                  <div className={s.itemImageWrap}>
                    {extraFeaturesImages[idExtraFeatureType] && (
                      <Image
                        src={`/img/icons/extra-features/${extraFeaturesImages[idExtraFeatureType]}.png`}
                        width={42}
                        height={39}
                        quality={100}
                        alt={getExtraFeatureName(idExtraFeatureType)}
                      />
                    )}
                  </div>

                  <div className={s.itemContentInner}>
                    <div className={s.itemHeading}>{getExtraFeatureName(idExtraFeatureType)}</div>
                    <div className={s.itemText}>
                      {percentageSurcharge
                        ? `+${percentageSurcharge}% to the page price`
                        : flatSurcharge
                        ? `$${flatSurcharge}`
                        : ""}
                    </div>
                  </div>
                </div>
                <span className={s.itemArrow}>
                  <SpriteIcon icon={iconArrowRightB} className={s.itemIcon} />
                  <span>get feature</span>
                </span>
              </div>
            )
          )}
      </div>
    </div>
  );
};
